<script setup>
const { $isMobile } = useNuxtApp();

definePageMeta({
	ssr: false,
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "名師團隊",
});

useHead({
	title: "名師團隊 - 全球權威命理大師-先知命局",
	meta: [
		{
			name: "keywords",
			content: "名師團隊，八字算命大師，專業命理師，算命老師",
		},
		{
			name: "description",
			content:
				"真人算命,大師兄,親算,算命,占卜,桃花愛情,分手,復合,單身,婚姻問題,事業發展,流年生涯,剖腹擇日選時,親子問題,家庭問題,命名服務",
		},
	],
});

// 动态导入组件（代码分割）
const Component = $isMobile
	? defineAsyncComponent(() => import("@variants/seer/master-team/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/seer/master-team/pc/index.vue"));
</script>

<template>
	<ClientOnly>
		<Component />
	</ClientOnly>
</template>
